import { FilterFilled, FilterOutlined, OrderedListOutlined, ProfileOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { fetchWorkflow } from "../../store/workflow";
import { Checkbox, Dropdown, Menu } from "antd";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import { acessoSelector } from "../../store/acessos";
import { fetchEmpresas } from "../../store/empresas";
import ActionLink from "../action-link";
import EmpresaDrawer from "./_EmpresaDrawer";
import styles from "./_styles.less";
import { funcoesSelector } from "../../store/autenticacao";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import { isGestorSelector } from "../../store/autenticacao";
import { useRouteMatch } from "react-router";
import TiposTarefasDrawer from "./TiposTarefas";

export default function WorkflowMenu({ showCreate, extraMenu }) {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const workflowId = match.params.id;
  const dispatch = useDispatchWithResult();
  const funcoes = useSelector(funcoesSelector);
  const acesso = useSelector(acessoSelector);
  const isGestor = useSelector(isGestorSelector);

  const [empresa, setEmpresa] = useState();
  const [filterVisible, setFilterVisible] = useState(false);
  const [checkFilter, setCheckFilter] = useState(false);
  const [empresaDrawerVisible, setEmpresaDrawerVisible] = useState(false);
  const [TiposTarefasDrawerVisible, setTiposTarefasDrawerVisible] = useState(false);

  const hasCadastro = funcoes?.includes("cadastro") && acesso?.funcoes?.includes("cadastro");

  const handleCreateClick = () => {
    setEmpresa({ acessoId: acesso?.id });
    setEmpresaDrawerVisible(true);
  };

  const handleCreateTarefas = () => {
    setTiposTarefasDrawerVisible(true);
  };

  const handleEmpresaChange = () => {
    dispatch(fetchEmpresas({ acessoId: acesso?.id, modulo: "workflow" }));
  };

  const handleEmpresaDrawerClose = () => {
    setEmpresaDrawerVisible(false);
  };

  const handleTiposTarefasDrawerClose = () => {
    setTiposTarefasDrawerVisible(!TiposTarefasDrawerVisible);
  };

  const handleEmpresaDrawerAfterClose = () => {
    setEmpresa(undefined);
  };

  const handleFilterAvisosChange = () => {
    setCheckFilter(!checkFilter);
    unwrapAxiosPromise(dispatch(fetchWorkflow({ workflowId, arquivamento: !checkFilter })));
  };

  const buttons = [];

  buttons.push(<ActionLink key="tarefas" title={t("Visualizar Tipos Tarefas")} noTitle icon={<OrderedListOutlined />} onClick={handleCreateTarefas} />);

  buttons.push(
    <Dropdown
      key="filter-dropdown"
      overlay={
        <Menu theme="dark" mode="horizontal" selectable={false} disabledOverflow>
          <Menu.ItemGroup title={t("Exibir")} className={styles["workflow-menu-item-group"]}>
            <Menu.Item key="Arquivadas" className={styles["workflow-menu-item"]}>
              <Checkbox checked={checkFilter} onChange={handleFilterAvisosChange}>
                {t("Apenas Arquivadas")}
              </Checkbox>
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu>
      }
      visible={filterVisible}
      onVisibleChange={setFilterVisible}
    >
      <ActionLink key="filter" icon={checkFilter ? <FilterFilled /> : <FilterOutlined />} onClick={() => setFilterVisible(true)} />
    </Dropdown>
  );
  if (showCreate && hasCadastro) {
    buttons.push(<ActionLink key="create" title={t("Criar Empresa")} noTitle icon={<ProfileOutlined />} onClick={handleCreateClick} />);
  }
  if (extraMenu && extraMenu.length > 0) buttons.push(extraMenu);

  return (
    <div className={styles["workflow-menu"]}>
      {buttons}
      {hasCadastro && <EmpresaDrawer value={empresa} onChange={handleEmpresaChange} visible={empresaDrawerVisible} onClose={handleEmpresaDrawerClose} onAfterClose={handleEmpresaDrawerAfterClose} />}
      {isGestor && <TiposTarefasDrawer visible={TiposTarefasDrawerVisible} onClose={handleTiposTarefasDrawerClose} workflowId={workflowId} />}
    </div>
  );
}

WorkflowMenu.propTypes = {
  showCreate: PropTypes.bool,
  showFilter: PropTypes.bool,
  extraMenu: PropTypes.array,
};
